"use strict";

import UsersPermissionsList from './admin/users/permissions/list';
import UsersCreate from './admin/users/create';
import ClientsEdit from './admin/clients/edit';
import CardsList from './cards/list';
import FileUpload from './librairies/File/Upload';
import FileRemove from './librairies/File/Remove';
import SignIn from './signin';
import MailingsList from './admin/mailings/list';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#users-permissions-list')) {
    new UsersPermissionsList(document.querySelector('#users-permissions-list'));
  }

  if (document.querySelector('#users-create')) {
    new UsersCreate(document.querySelector('#users-create'));
  }

  if (document.querySelector('#clients-edit')) {
    new ClientsEdit(document.querySelector('#clients-edit'));
  }

  if (document.querySelector('.section-sending-cards')) {
    new CardsList();
  }

  if (document.querySelectorAll(".file-upload").length > 0) {
    document.querySelectorAll(".file-upload").forEach(element => {
      new FileUpload(element);
      new FileRemove(element);
    });
  }

  if (document.querySelector("body#signin")) {
    new SignIn(document.querySelector("body#signin"));
  }

  if (document.querySelector('#mailings-list')) {
    new MailingsList(document.querySelector('#mailings-list'));
  }

  /****************************************************************************
   * Processes applicable to all pages.
   ***************************************************************************/

  document.querySelectorAll('.alert').forEach(element => {
    element.addEventListener('click', () => {
      element.remove();
    });
  });

  /****************************************************************************
   * Set local storage variables.
   ***************************************************************************/

  if (!localStorage.getItem('isDevMode') && require('../../config.json').pillar.dev === true) {
    localStorage.setItem('isDevMode', '1');
  }
});
